(function(){
  function boot(root){
    if (root.dataset.eha3xReady==='1') return;
    root.dataset.eha3xReady='1';
    var bar=root.querySelector('[data-eha3x-progress]');
    var sticky=root.querySelector('[data-eha3x-cta]');
    var product=root.querySelector('[data-eha3x-product]');
    var footer=root.querySelector('.eha3x-notes');
    var ticking=false;
    function update(){
      ticking=false;
      var rect=root.getBoundingClientRect();
      var entire=Math.max(1,root.offsetHeight-window.innerHeight);
      var local=-rect.top;
      var pct=Math.min(100,Math.max(0,local/entire*100));
      if(bar) bar.style.width=pct+'%';
      if(sticky && product){
        var show=product.getBoundingClientRect().top<window.innerHeight*.75;
        if(footer && footer.getBoundingClientRect().top<window.innerHeight-60) show=false;
        sticky.classList.toggle('is-visible',show);
      }
    }
    function schedule(){if(ticking)return;ticking=true;requestAnimationFrame(update)}
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    update();
  }
  function init(){document.querySelectorAll('[data-eha3x-root]').forEach(boot)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
